import { render } from "./footer.html?vue&type=template&id=52720058&scoped=true&lang=html&external"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./_footer.mobile.scss?vue&type=style&index=0&id=52720058&lang=scss&scoped=true&external"
import "./_footer.desktop.scss?vue&type=style&index=1&id=52720058&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52720058"]])

export default __exports__